import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/decrypt'

const decrypt = (payload, organization) => AxiosClient.post(
  resource, payload, { headers: { organization } }
)

export {
  decrypt
}
